import { defineMessages } from 'react-intl';

export default defineMessages({
    travelCountry: {
        id: 'fnol.adac.contact-details-page.Travel country',
        defaultMessage: 'Travel country'
    },
    travelCity: {
        id: 'fnol.adac.contact-details-page.Travel city',
        defaultMessage: 'City'
    },
    adacMembershipNumber: {
        id: 'fnol.adac.contact-details-page.ADAC Membership number',
        defaultMessage: 'ADAC Membership number'
    },
    contactPerson: {
        id: 'fnol.adac.contact-details-page.Contact Person',
        defaultMessage: 'Contact Person'
    },
    contactPersonSelect: {
        id: 'fnol.adac.contact-details-page.Different contact person',
        defaultMessage: 'Different contact person'
    },
    contactPersonDescription: {
        id: 'fnol.adac.contact-details-page.Different contact person description',
        defaultMessage: 'Select this option if someone else wants to contact us on behalf of the patient.'
    },
    contactDetailsLabel: {
        id: 'fnol.adac.contact-details-page.Patient Data',
        defaultMessage: 'Patient data'
    },
    acceptPrivacyPolicy: {
        id: 'fnol.adac.contact-details-page.Accept privacy policy',
        defaultMessage: 'Accept privacy policy'
    },
    furtherStepsConsent: {
        id: 'fnol.adac.contact-details-page.Further steps consent',
        defaultMessage: 'In the further steps we need personal data in order to process your request quickly. For this we need your consent to our data { dataProtection } & { termsOfUse }.'
    },
    dataProtection: {
        id: 'fnol.adac.contact-details-page.protection declaration',
        defaultMessage: 'protection declaration and terms of use'
    },
    termsOfUse: {
        id: 'fnol.adac.contact-details-page.terms of use',
        defaultMessage: 'terms of use'
    },
    dataProtectionLink: {
        id: 'fnol.adac.contact-details-page.Data protection link',
        defaultMessage: 'https://www.adac.de/datenschutz-dsgvo/ambulance-app/'
    },
    termsOfUseLink: {
        id: 'fnol.adac.contact-details-page.Terms of use link',
        defaultMessage: 'https://www.adac.de/datenschutz-dsgvo/ambulance-app/nutzungsbedingungen/'
    },
});
